import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../components/layout/Sidebar';
import TopBar from '../components/layout/TopBar';
import ReconnectBanner from '../components/status/ReconnectBanner';
import useAppStore from '../store';

function AgencyLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const approvals = useAppStore((state) => state.approvals);
  const sidebarOpen = useAppStore((state) => state.sidebarOpen);
  const setSidebarOpen = useAppStore((state) => state.setSidebarOpen);
  const clearSessionAction = useAppStore((state) => state.clearSession);

  // Sign out (auth-full-spec §5.1): clear the client-side session (PB tokens
  // are stateless — the local clear IS the logout) and route to /#/login.
  const handleSignOut = () => {
    clearSessionAction();
    navigate('/login', { replace: true });
  };

  const activePage = location.pathname.split('/')[1] || 'cockpit';
  const titles = {
    cockpit: 'Cockpit',
    approvals: 'Approvals',
    agents: 'Agents',
    scheduler: 'Scheduler',
    brain: 'Brain',
    channels: 'Channels',
    console: 'Console',
    settings: 'Settings'
  };

  const handleNavigate = (page) => {
    const routes = ['cockpit', 'approvals', 'agents', 'scheduler', 'brain', 'channels', 'console'];
    navigate(`/${routes.includes(page) ? page : 'settings'}`);
  };

  return (
    <div className="ops-shell">
      <Sidebar
        activePage={activePage}
        onNavigate={handleNavigate}
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      {sidebarOpen && (
        <button className="sidebar-scrim" onClick={() => setSidebarOpen(false)} type="button" />
      )}
      <div className="workspace">
        <TopBar
          onSignOut={handleSignOut}
          queueCount={approvals.length}
          title={titles[activePage] || 'Agency'}
          onMenu={() => setSidebarOpen(true)}
        />
        {/* S7.1/S7.2: stale/lost-connection banner — visible on every agency route. */}
        <ReconnectBanner />
        <Outlet />
      </div>
    </div>
  );
}

export default AgencyLayout;